import React, { useContext } from 'react';
import { Box, Divider, Link, Typography, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import LaunchIcon from '@material-ui/icons/Launch';
import ForumIcon from '@material-ui/icons/Forum';
import Draggable from './Draggable';
import { getBaseUrl } from 'helper/utils';
import { colors } from 'theme/color-palette';
import { FEATURES } from 'helper/basicFeatureFlag';
import { charterLinks, basicLinks } from './links';
import { UserPortalContext } from 'context/appcontext';
import { HelpLinkItem, useStyles } from './Help.style';
import { KNOWLEDGE_BASE_PATH } from 'constants/constant';
import HelpIcon from '@material-ui/icons/Help';
import articleIcon from 'assets/svgs/article.svg';

const HelpModal = ({ onClose }) => {
	const classes = useStyles();
	const portalUserContext = useContext(UserPortalContext);
	const { customerType } = portalUserContext;
	const {
		HELP: { BASIC_LINK_ITEMS: basicLinkItems }
	} = FEATURES[customerType].PREVIEW_PAGE;

	let helpLinks = charterLinks;
	let knowledgeBaseURL = `${getBaseUrl()}/${KNOWLEDGE_BASE_PATH}`;
	if (basicLinkItems) {
		helpLinks = basicLinks;
		knowledgeBaseURL = `${getBaseUrl()}/knowledgeBase/basic`;
	}

	return (
		<Draggable initialPos={{ x: 'calc(100vw - 376px)', y: 114 }}>
			<Box className={classes.modalContainer}>
				<Box className={classes.header}>
					<HelpIcon className={classes.helpIcon} />
					<Typography className={classes.title}>Help</Typography>
					<IconButton onClick={onClose} className={classes.closeBtn} aria-label="Close">
						<CloseIcon style={{ color: colors.FONT_COLOR }} />
					</IconButton>
				</Box>
				<Divider />
				<Box style={{ display: 'flex', flexDirection: 'column', height: '692px' }}>
					<Box className={classes.subHeader}>
						<Typography className={classes.subTitle}>Report Builder Knowledge Base</Typography>
						<Link
							href={knowledgeBaseURL}
							target="_blank"
							underline="none"
							className={classes.subHeaderLink}
							aria-label="Report Builder Knowledge Base">
							Open
							<LaunchIcon style={{ width: 14, height: !4 }} />
						</Link>
					</Box>
					{helpLinks.map(({ title, path }, key) => (
						<HelpLinkItem
							key={key}
							onClick={() => window.open(`${getBaseUrl()}/${path}`, '_blank', 'noreferrer')}>
							<div style={{ margin: '5px 10px 0 0' }}>
								<img src={articleIcon} alt="article-icon"></img>
							</div>
							<Typography className={classes.articleItem}>{title}</Typography>
						</HelpLinkItem>
					))}
					<Box style={{ marginTop: 'auto', paddingTop: '8px' }}>
						<Divider />
						<HelpLinkItem
							className={classes.contactSupport}
							onClick={() => {
								window.open(`${getBaseUrl()}/support`, '_blank', 'noreferrer');
							}}>
							<ForumIcon className={classes.supportIcon} />
							<Typography className={classes.contactSupportText}>Contact support</Typography>
						</HelpLinkItem>
					</Box>
				</Box>
			</Box>
		</Draggable>
	);
};

export default HelpModal;
